import { useState } from 'react';
import { Navigate, useSearchParams } from 'react-router';

import { buildIncidentListOpenNewIncidentDialogUrl } from './createIncidentRedirect';

export function CreateIncidentPage() {
  const [searchParams] = useSearchParams();
  const [redirectUrl] = useState(() => buildIncidentListOpenNewIncidentDialogUrl(searchParams));

  return <Navigate to={redirectUrl} />;
}
